<template>
    <b-modal
        id="modal-news-config"
        ref="modal-news-config"
        centered
        ok-title="Aceptar"
        ok-variant="primary"
        cancel-title="Cancelar"
        title="Configuración de Noticias"
        :ok-disabled="disableOkButton"
        @ok="onUpdate"
        @show="loadSiteNewsConfig()"
    >
        <b-form id="news-config-form" @submit.stop.prevent="onSubmit()">
            <b-form-group id="input-group-notifications">
                <b-form-checkbox
                    v-model="form.displayTwitterFeed"
                    name="notice"
                    :value="1"
                    :unchecked-value="0"
                    size="lg"
                    switch
                    :disabled="formDisabled"
                >
                    Activar Feed de Twitter
                </b-form-checkbox>
            </b-form-group>
            <b-alert show variant="light" v-if="form.displayTwitterFeed">
                <p class="text-dark">
                    Actualmente solo se permiten ids de Twitter de <strong>Perfiles</strong>.<br />
                    <u>Ejemplo:</u> En la url del siguiente perfil de twitter: https://twitter.com/aypucv
                    el ID a colocar en el formulario sería: <strong>aypucv</strong>
                </p>
            </b-alert>
            <b-form-group
                v-if="form.displayTwitterFeed"
                id="input-group-twitterId"
                label="*Twitter ID:"
                label-for="input-twitterId"
                description="Por favor escriba el ID de Twitter del perfil que desea aparezca en el feed."
            >
                <b-form-input
                    id="input-twitterId"
                    v-model="$v.form.twitterId.$model"
                    type="text"
                    required
                    :disabled="formDisabled"
                    :state="validateState('twitterId')"
                />
                <b-form-invalid-feedback id="input-twitterId-feedback">
                    <ul>
                        <li v-if="!$v.form.twitterId.required">Este campo es requerido.</li>
                    </ul>
                </b-form-invalid-feedback>
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { requiredUnless } from 'vuelidate/lib/validators'

export default {
    name: 'SiteNewsConfig',
    data () {
        return {
            formDisabled: false,
            form: {
                displayTwitterFeed: 0,
                twitterId: ''
            },
            oldForm: {
                displayTwitterFeed: 0,
                twitterId: ''
            }
        }
    },
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters([
            'getActiveSiteNewsList'
        ]),
        formChanged () {
            if (this.oldForm.displayTwitterFeed !== this.form.displayTwitterFeed) {
                return true
            } else if (this.form.displayTwitterFeed && this.oldForm.twitterId !== this.form.twitterId) {
                return true
            }
            return false
        },
        disableOkButton () {
            return this.formDisabled || this.$v.form.$invalid || !this.formChanged
        }
    },
    validations: {
        form: {
            twitterId: {
                required: requiredUnless(function () {
                    return !this.form.displayTwitterFeed
                })
            }
        }
    },
    methods: {
        ...mapActions([
            'updateCourseSiteNewsConfig'
        ]),
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        async onUpdate (bvModalEvt) {
            bvModalEvt.preventDefault() // Prevent modal from closing
            await this.onSubmit() // Trigger submit handler
        },
        loadSiteNewsConfig () {
            if (this.activeSite) {
                this.form.displayTwitterFeed = this.activeSite.config.notices_type
                this.oldForm.displayTwitterFeed = this.activeSite.config.notices_type
                this.form.twitterId = this.activeSite.config.notices_twitter
                this.oldForm.twitterId = this.activeSite.config.notices_twitter
                if (this.form.twitterId === '-') {
                    this.form.twitterId = ''
                    this.oldForm.twitterId = ''
                }
            }
        },
        async onSubmit () {
            let loader = null
            // Create a const copy
            const payloadData = { ...this.form, courseSiteId: this.activeSite.id }
            try {
                this.formDisabled = true
                loader = this.$root.$loading.show()
                await this.updateCourseSiteNewsConfig(payloadData)
                this.$store.commit('SET_ACTIVE_SITE_NEWS_CONFIG', payloadData)
                this.$root.successToast(`La configuración se ha actualizado exitosamente.`)
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-news-config')
                })
            } catch (err) {
                console.log({ err: err })
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    }
}
</script>
